<template>
  <v-dialog v-model="show" max-width="500px">
    <v-card>
      <v-card-title class="text-h5">
        {{ formTitle }}
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.name"
                label="Name"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="editedItem.description"
                label="Description"
                rows="3"
              ></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-switch
                v-model="editedItem.active"
                label="Active"
                color="accent"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="rounded-pill" text @click="close">
          Cancel
        </v-btn>
        <v-btn
          class="rounded-pill elevation-0"
          color="accent"
          :disabled="editedItem.name == ''"
          @click="save"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ProgramDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    editedIndex: {
      type: Number,
      default: -1,
    },
    editedItem: {
      type: Object,
      default: () => ({
        name: '',
        description: '',
        active: true,
      }),
    },
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    formTitle() {
      return this.editedIndex === -1 ? 'New Program' : 'Edit Program'
    },
  },
  methods: {
    close() {
      this.show = false
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    },
  },
}
</script>
